export const sx = {
    root: {
        padding: '2rem',
        height:'100%'
    },
}